module.exports = __webpack_public_path__ + "img/DB-banner.cc8fb82e.png";